import { ComponentProps, ComponentType } from 'react';
import { AppleIcon } from '../../../assets/icons/AppleIcon';
import { GoogleIcon } from '../../../assets/icons/GoogleIcon';
import { SocialProviderId } from '../constants/socialAuth';

/*
 * Descrição de cada provedor de login social.
 *
 * O botão, o hook e a página de callback são idênticos entre Google e Apple, e
 * os endpoints também (só muda o segmento do provedor na URL) — o que muda é só
 * isto. Um objeto por provedor em vez de arquivos duplicados: um terceiro
 * provedor é uma entrada nova aqui, não mais três arquivos copiados.
 */
export interface SocialProvider {
  /** Mesmo id usado no caminho do endpoint: /auth/{id}/url e /auth/{id}/callback. */
  id: SocialProviderId;
  /** Texto do botão na tela de login. */
  buttonLabel: string;
  /** Título mostrado na página de callback enquanto o login finaliza. */
  callbackTitle: string;
  Icon: ComponentType<ComponentProps<'svg'>>;
  /*
   * Classe aplicada ao ícone. O logo do Google é multicolorido e precisa de
   * `fill-none` para o `fill-current` da variante não achatá-lo; a marca da
   * Apple é monocromática e deve seguir a cor do texto, então fica sem classe.
   */
  iconClassName?: string;
}

export const GOOGLE_PROVIDER: SocialProvider = {
  id: 'google',
  buttonLabel: 'Entrar com Google',
  callbackTitle: 'Conectando com Google',
  Icon: GoogleIcon,
  iconClassName: 'fill-none',
};

export const APPLE_PROVIDER: SocialProvider = {
  id: 'apple',
  buttonLabel: 'Entrar com Apple',
  callbackTitle: 'Conectando com Apple',
  Icon: AppleIcon,
};
